import axios from 'axios';

// API URL - use env var or default to relative URLs (same origin)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  displayName?: string;
}

export interface User {
  id: string;
  email: string;
  display_name?: string;
  phone_number?: string;
  occupation?: string;
  bio?: string;
  photo_url?: string;
  is_location_visible?: boolean;
  last_login?: string;
  created_at?: string;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<User> {
    const response = await api.post('/api/auth/signin', credentials);
    return response.data.data.user;
  },

  async register(userData: RegisterData): Promise<User> {
    const response = await api.post('/api/auth/signup', userData);
    return response.data.data.user;
  },

  async logout(): Promise<void> {
    await api.get('/api/auth/logout');
  },

  async getCurrentUser(): Promise<User | null> {
    try {
      const response = await api.get('/api/auth/current/user');
      return response.data.data.user;
    } catch (error) {
      return null;
    }
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post('/api/auth/forgot-password', { email });
  },

  async updateProfile(profileData: Partial<User>): Promise<User> {
    const response = await api.put('/api/auth/profile', profileData);
    return response.data.data.user;
  },

  async getUserProfile(userId: string): Promise<User> {
    const response = await api.get(`/api/auth/user/${userId}/profile`);
    return response.data.data;
  }
};

export default authService;